import { useState } from 'react'
import { Button } from '@klear/ui/components/button'
import { Download, Eye, Loader2 } from 'lucide-react'
import { withAttachmentDisposition } from '@klear/upload/file-url'
import { useFileDownload } from '@klear/ui/lib/download-file'
import { downloadPdf } from '@klear/ui/lib/download-pdf'
import PdfPreviewModal from '@klear/ui/components/pdf-preview-modal'

interface PdfModalWithDownloadProps {
  pdfDocument?: React.ReactElement
  pdfUrl?: string
  title: string
  filename?: string
}

export const PdfModalWithDownload: React.FC<PdfModalWithDownloadProps> = ({ pdfDocument, pdfUrl, title, filename }) => {
  const [open, setOpen] = useState(false)
  const { startDownload, isDownloading } = useFileDownload()

  const handleButtonClick = () => {
    setOpen(true)
  }

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen)
  }

  const handleDownload = () => {
    if (pdfDocument && filename) {
      downloadPdf(pdfDocument, filename)
    } else if (pdfUrl) {
      startDownload(withAttachmentDisposition(pdfUrl), filename || 'document.pdf')
    }
  }

  return (
    <>
      {open && (
        <PdfPreviewModal
          title={title}
          pdfDocument={pdfDocument}
          pdfUrl={pdfUrl}
          open={open}
          onOpenChange={handleOpenChange}
        />
      )}
      <div className="flex gap-1">
        <Button variant="ghost" size="sm" onClick={handleButtonClick}>
          <Eye />
        </Button>
        {(pdfDocument || pdfUrl) && (
          <Button variant="ghost" size="sm" onClick={handleDownload} disabled={isDownloading}>
            {isDownloading ? <Loader2 className="animate-spin" /> : <Download />}
          </Button>
        )}
      </div>
    </>
  )
}
